module.exports = __webpack_public_path__ + "img/start_up_roku.65b9a85b.png";